<template>
  <div class="login clearfix">
    <h3>
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      非法操作，跳转中
    </h3>
  </div>
</template>

<script>
export default {
  name: 'login',
  components:{
  },
  metaInfo: {
    title: '雪帝数字音频', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '雪帝数字音频'
    },
      {
        name: 'description',
        content: '雪帝数字音频'
      }]
  },
  created() {
    window.location.href = process.env.BASE_URL;
  }
}
</script>

<style scoped lang='less'>
.login{
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 1200px) {
}
</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue